<div
    class="publish flex-footer"
    [ngClass]="{
        minHeight: currentView === 'Loading',
        'let-mat-dialog min-dialog-height': currentView === 'SelectPortals',
        safariMobileHeight: isMobileSafariBrowser,
    }"
>
    <section class="head">
        <article class="subtitle">{{ title | translate }}</article>
        <button mat-icon-button [disabled]="isLoading" clickAndKeydown (actionTriggered)="cancel()">
            <mat-icon>close</mat-icon>
        </button>
    </section>

    <aside class="loader">
        <loading-indicator [isEmbedded]="true" />
    </aside>

    @if (currentView === 'SelectPortals' && !canPublishToAkeliusWebsite()) {
        <ak-message-box class="warning" [type]="'warning'">
            {{ 'VALIDATION_MESSAGES.INVALID_PICTURES_FOR_AKELIUS_WEBSITE' | translate }}
        </ak-message-box>
    }

    <div style="display: contents">
        @switch (currentView) {
            @case ('Loading') {
                <section class="wait">{{ loadingText | translate }}</section>
            }
            @case ('SelectPortals') {
                <section class="select-portals">
                    <article class="heading">{{ 'SHARED_COMPONENT.SELECT_PORTALS' | translate }}</article>
                    <aside class="portals">
                        @for (portal of publicationPortals; track $index) {
                            <mat-checkbox
                                [(ngModel)]="portal.isSelected"
                                [disabled]="shouldDisablePortalSelector(portal.context)"
                            >
                                {{ 'PORTALS.' + portal.context | translate }}
                            </mat-checkbox>
                        }
                    </aside>
                    <ak-message-box class="warning prospect-limit" [type]="'info'">
                        {{ 'PUBLICATION.PROSPECT_LIMIT_INFO' | translate }}
                    </ak-message-box>
                    <mat-form-field class="prospect-limit">
                        <mat-label>{{ 'PUBLICATION.PROSPECT_LIMIT_LABEL' | translate }}</mat-label>
                        <input [formControl]="prospectLimitControl" type="number" matInput />
                    </mat-form-field>
                    <aside class="actions">
                        <button matButton="outlined" clickAndKeydown (actionTriggered)="cancel()">
                            {{ 'SHARED_COMPONENT.CANCEL' | translate }}
                        </button>
                        <button
                            matButton="filled"
                            clickAndKeydown
                            (actionTriggered)="portalSelectionConfirmed()"
                            [disabled]="!canPublish"
                        >
                            {{ 'SHARED_COMPONENT.PUBLISH' | translate }}
                        </button>
                    </aside>
                </section>
            }
            @case ('Success') {
                <section class="success">
                    <article>{{ successText | translate }}</article>
                    @if (workflowResults.length > 0) {
                        <aside class="list">
                            @for (result of workflowResults; track $index) {
                                <div class="page">
                                    @if (!result.url) {
                                        <span>- {{ 'PORTALS.' + result.portalName | translate }}</span>
                                    }
                                    @if (result.url) {
                                        <span
                                            >-
                                            <a class="link" href="{{ result.url }}" target="_blank" rel="noopener">{{
                                                'PORTALS.' + result.portalName | translate
                                            }}</a></span
                                        >
                                    }
                                    <i class="material-icons" [ngClass]="result.isSuccess ? 'success' : 'error'">{{
                                        result.isSuccess ? 'check_circle' : 'error'
                                    }}</i>
                                </div>
                            }
                        </aside>
                    }
                    <aside class="actions">
                        <button matButton="outlined" clickAndKeydown (actionTriggered)="navigateToAdvert()">
                            {{ 'SHARED_COMPONENT.ADVERT' | translate }}
                        </button>
                        <button matButton="outlined" clickAndKeydown (actionTriggered)="navigateToDashboard()">
                            {{ 'SHARED_COMPONENT.DASHBOARD' | translate }}
                        </button>
                        <a style="display: none" #downloadLink></a>
                    </aside>
                </section>
            }
            @case ('Error') {
                <section class="error">
                    <ak-message-box [type]="'error'">
                        {{ errorText }}
                    </ak-message-box>
                    <aside class="actions">
                        <button matButton="outlined" clickAndKeydown (actionTriggered)="navigateToAdvert()">
                            {{ 'SHARED_COMPONENT.ADVERT' | translate }}
                        </button>
                        <button matButton="outlined" clickAndKeydown (actionTriggered)="navigateToDashboard()">
                            {{ 'SHARED_COMPONENT.DASHBOARD' | translate }}
                        </button>
                    </aside>
                </section>
            }
            @case ('SelectUnpublishReason') {
                <section class="unpublish-reason">
                    <mat-form-field>
                        <mat-label>{{ 'SHARED_COMPONENT.MODAL_UNPUBLISH_REASON' | translate }}</mat-label>
                        <mat-select [(ngModel)]="selectedReason">
                            @for (item of unpublishReasonItems; track $index) {
                                <mat-option [value]="item.context">
                                    {{ item.name | translate }}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    <aside class="actions">
                        <button matButton="outlined" clickAndKeydown (actionTriggered)="cancel()">
                            {{ 'SHARED_COMPONENT.CANCEL' | translate }}
                        </button>
                        <button matButton="filled" clickAndKeydown (actionTriggered)="unpublishReasonConfirmed()">
                            {{ 'SHARED_COMPONENT.SUBMIT' | translate }}
                        </button>
                    </aside>
                </section>
            }
        }
    </div>
</div>
